const AddCountry = () => {
  return <div>Country cannot be added</div>;
};

export default AddCountry;
